module.exports = __webpack_public_path__ + "media/src/application/media/svg/line-7153e3a0277815a2e1d8de2f89d1bddd.svg";